module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALtJREFUeNrs1LENwjAQhWFjZQB6moyQjJBNLDEBkzABEpswAhkhDT0jcIWR0OHEuQMKpP+TnOLs5ySW7RAAAAAA4Fc2b5XTbSvPo7T0Uj1LO4T97j47kzdnzDaF+EVap2op1/qF13pzpmxUf5oKwacu95dWyJdzZKMa0FZWojXW1/SbsvHfDp3+4KkyfjLW1/SbsqVb4jqzp0Y5sf3CXvTljNnSlhjylRLUFTNUVsKb+zQLAAAAAF/yEGAAo5Q30+66RbgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/default/lab/button.png
// module id = aDGe
// module chunks = 2